import { Forage } from '../store/localforage'
import { constants as steamConstants } from '../features/Steam'
import { constants as settingsConstants } from '../features/Settings'
import { constants as toasterConstants } from '../features/Toaster'
import { constants as usersConstants } from '../features/Users'

function updateUsers(users) {
    try {
        // Finally save to localForage
        new Forage().setUsers(users)
    } catch (error) {
        console.info(`Couldn't update users in localforage: ${error}`)
    }
}

function updateUiSettings(uiSettings) {
    try {
        new Forage().setUISettings(uiSettings)
    } catch (error) {
        console.info(`Couldn't update ui settings in localforage: ${error}`)
    }
}

function updateUsedSteamTicket(ticket) {
    try {
        new Forage().setUsedSteamTicket(ticket)
    } catch (error) {
        console.info(`Couldn't update used steam ticket in localforage: ${error.message}`)
    }
}

function updateMotds(state) {
    try {
        new Forage().setMotds(state)
    } catch (error) {
        console.info(`Couldn't update motds in localforage: ${error}`)
    }
}

const LocalForageMiddleWare = () => next => (action) => {
    switch (action.type) {
        case usersConstants.USERS_CHANGED: {
            const result = next(action)
            updateUsers(action.payload)
            return result
        }

        case settingsConstants.UI_SETTINGS_CHANGED: {
            const result = next(action)
            updateUiSettings(action.payload)
            return result
        }

        case steamConstants.STEAM_TICKET_CHANGED: {
            const result = next(action)
            updateUsedSteamTicket(action.payload)
            return result
        }

        case toasterConstants.MOTDS_CHANGED: {
            const result = next(action)
            updateMotds(action.payload)
            return result
        }

        default:
            return next(action)
    }
}

export default LocalForageMiddleWare



// WEBPACK FOOTER //
// ./src/middlewares/LocalForageMiddleware.js